import React, { Component } from "react";
import { DKLabel, DKInput, DKButton, showAlert } from "deskera-ui-library";
import { getCapitalized } from "../../utility/Utility";
import CustomDomainSection from "./CustomDomainSection";
import DomainManager from "../../managers/DomainManager";

/*
PROPS
- title
- header
- subHeader
- headerIcon
- onCancel
- onSave (title)
- allowDomainSelection
*/

class SavePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title ? this.props.title : "",
      domain:
        this.props.allowDomainSelection === true
          ? DomainManager.getLatestDomain()
          : null,
      submitTapped: false,
    };
  }
  render() {
    return (
      <div className="transparent-background">
        <div
          className="popup-window justify-content-center align-items-center justify-content-start-mobile"
          style={{ padding: 30, paddingTop: 20 }}
        >
          <DKLabel
            text={`<span style="font-size:30px">${this.props.headerIcon}</span> ${this.props.header}`}
            className="fw-m fs-xl"
          />
          {this.props.subHeader && (
            <DKLabel
              text={this.props.subHeader}
              className="text-gray fs-m mt-s text-align-center"
            />
          )}
          <div className="parent-width">
            <DKInput
              title=""
              value={this.state.title}
              onChange={(text) => {
                this.setState({ title: getCapitalized(text) });
              }}
              direction="vertical"
              className="mt-xl "
              canValidate={this.state.submitTapped}
            />
          </div>
          {this.props.allowDomainSelection === true && (
            <CustomDomainSection
              className="mt-l"
              onDomainSelect={(domain) => {
                this.setState({ domain: domain });
              }}
            />
          )}
          {this.getFooter()}
        </div>
      </div>
    );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  cancelTapped = () => {
    this.props.onCancel();
  };

  saveTapped = () => {
    if (
      this.state.domain &&
      DomainManager.isDomainVerified(this.state.domain) === false
    ) {
      showAlert(
        "Domain not verified!",
        "Your domain is not yet verified/approved. Please wait till it get approved.<br/><br/>Or select a default domain from dropdown to proceed."
      );
      return;
    }
    this.setState({ submitTapped: true });
    let title = this.state.title;
    if (title && title.trim().length > 0) {
      this.props.onSave(
        this.state.title,
        DomainManager.getDomainName(this.state.domain)
      );
    }
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getFooter() {
    return (
      <div className="row mt-xl justify-content-center">
        <DKButton
          title="Cancel"
          className="bg-gray1 border-m"
          onClick={this.cancelTapped}
        />
        <DKButton
          title="Save"
          className="bg-app text-white ml-m"
          onClick={this.saveTapped}
        />
      </div>
    );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
}

export default SavePopup;
